/* eslint-disable no-nested-ternary */
import { getHeaderName } from 'src/components/collapsible-table/table-column-prep';
import {
  Dialog,
  LinearProgress,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  IconButton,
  CircularProgress
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { formatNumberUsingRegex } from '../../../../pricing-simulator';
import {
  Header,
  InputType,
  TableComponent
} from '../../../../pricing-simulator/types/generic-table.model';
import DisplayCell from '../../../../pricing-simulator/components/table-columns/display-cell';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/hooks';
import { axios } from 'src/lib';
import { prepDTPayload } from '../utils/dt-utils';
import { FETCH_DT_PBI_URL } from 'src/constants';

export default function DtPBIChart({
  info,
  moduleId,
  sourceId,
  scenarioId
}: {
  info: any;
  moduleId: number;
  sourceId: number;
  scenarioId: number;
}) {
  const appDispatch = useAppDispatch();
  const { globalFilterValue } = useAppSelector((state) => state.filters);

  // local state for loading
  const [isPbiChartFetched, setIsPbiChartFetched] = useState(false);
  // local state for pbi url
  const [urlData, setUrlData] = useState('');

  useEffect(() => {
    const filterPayload = prepDTPayload(globalFilterValue);
    const payload = {
      filter_inputs: filterPayload,
      row: {
        data: [info.row.original]
      }
    };

    appDispatch(() => {
      return axios
        .post(
          `${FETCH_DT_PBI_URL}${sourceId || 1}/${moduleId || 1}/${
            scenarioId || 1
          }/`,
          payload
        )
        .then((response) => {
          setUrlData(response.data.data);
          setIsPbiChartFetched(true);
        });
    });
  }, []);

  return (
    <>
      {!isPbiChartFetched ? (
        <Grid item sm='auto' display='flex' justifyContent='center'>
          <CircularProgress />
        </Grid>
      ) : (
        <div>
          <>
            <iframe
              width='100%'
              height='400px'
              allowFullScreen={true}
              src={urlData}
              title='iframe-div'
              frameBorder='0'
            ></iframe>
          </>
        </div>
      )}
    </>
  );
}
